import React, { Fragment } from "react";
import { FieldProps } from "@rjsf/core";
import { Tilannekuva } from "../../../../endpoints";
import { TMapAuditingCheck, TMapAuditingValue } from "../../IMapAuditing";
import { useAuthContext } from "../../../../auditoinnit/auth/AuthenticationProvider";
import { Header, List, Segment } from "semantic-ui-react";
import { isAuditCheckANote } from "../MapAuditing.utils";
import { MapAuditingListItem } from "../MapAuditingListItem";
import { useTargetingScheme } from "../../../../@tilannekuva/data/useTargetingScheme";

export const MapAuditingDisplayField: React.FC<FieldProps<any>> = (props) => {
    const { token } = useAuthContext();
    const { uiSchema = {} } = props as any

    const formData: TMapAuditingValue = props.formData ?? {};

    const mapReference = uiSchema["ui:mapReference"] || "tammisairaala_liikennemerkit";
    const titleType = uiSchema["ui:titleType"] || "none" as "key" | "none";

    const { data: targetingResult } = useTargetingScheme(mapReference, Tilannekuva.path, token);
    const { targetingScheme, map } = targetingResult || {}


    const renderListItem = (key: string, itemData: TMapAuditingCheck) => {
        if (!map) { return null }
        return (
            <MapAuditingListItem
                title={titleType === "key" ? key : ""}
                itemData={itemData}
                map={map}
            />
        );
    };


    const items = Object.keys(formData).map((key, index) => formData[key]).filter((data) => isAuditCheckANote(data));
    return (
        <Fragment>

            {items.length ? (
                <List>
                    {Object.keys(formData).map((key, index) =>
                        isAuditCheckANote(formData[key]) && renderListItem(key, formData[key])
                    )}
                </List>
            ) : <Segment textAlign="center" placeholder style={{ minHeight: "200px" }}>
                <Header> Ei kirjattuja huomiota  </Header>
            </Segment>
            }

        </Fragment>
    )
};
